export const LOCAL_STORAGE_KEY = 'sms_scheduler_local_calendar';

const DEMO_PHONE = '+1564544444';

const DEFAULT_CALENDAR = {
  id: 'local-calendar',
  name: 'My Calendar',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  events: [
    {
      id: 'local-event-1',
      name: 'Kids',
      content: 'Pick up kids at school in 30min',
      days: [3, 5], // Wednesday, Friday
      times: [17 * 60 + 30], // 5:30 PM
      eventContacts: [
        {
          contactId: 'demo-paul',
          name: 'Paul',
          verified: true,
          contact: {
            id: 'demo-paul',
            name: 'Paul',
            phoneNumber: DEMO_PHONE,
            verified: true,
          },
        },
      ],
    },
    {
      id: 'local-event-2',
      name: 'Mom medic',
      content: 'Take medecine now',
      days: [2, 4], // Tuesday, Thursday
      times: [10 * 60 + 30], // 10:30 AM
      eventContacts: [
        {
          contactId: 'demo-mom',
          name: 'Mom',
          verified: true,
          contact: {
            id: 'demo-mom',
            name: 'Mom',
            phoneNumber: DEMO_PHONE,
            verified: true,
          },
        },
      ],
    },
    {
      id: 'local-event-3-sun',
      name: 'Myself',
      content: 'Take out dog',
      days: [0], // Sunday
      times: [14 * 60], // 2:00 PM
      eventContacts: [
        {
          id: 'demo-me',
          name: 'Myself',
          phoneNumber: DEMO_PHONE,
          verified: true,
        },
      ],
    },
    {
      id: 'local-event-3-thu',
      name: 'Myself',
      content: 'Take out dog',
      days: [4], // Thursday
      times: [20 * 60], // 8:00 PM
      eventContacts: [
        {
          id: 'demo-me',
          name: 'Myself',
          phoneNumber: DEMO_PHONE,
          verified: true,
        },
      ],
    },
    {
      id: 'local-event-3-sat',
      name: 'Myself',
      content: 'Take out dog',
      days: [6], // Saturday
      times: [13 * 60], // 1:00 PM
      eventContacts: [
        {
          id: 'demo-me',
          name: 'Myself',
          phoneNumber: DEMO_PHONE,
          verified: true,
        },
      ],
    },
  ],
};

export function getLocalStorageCalendar() {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (e) {
    console.error('Failed to parse local calendar', e);
  }

  // Initialize if not present
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(DEFAULT_CALENDAR));
  return DEFAULT_CALENDAR;
}

export function saveLocalEvent(event) {
  const calendar = getLocalStorageCalendar();
  let updatedEvent = { ...event };

  if (!updatedEvent.id) {
    updatedEvent.id = `local-event-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }

  const existingIndex = calendar.events.findIndex(
    (e) => e.id === updatedEvent.id
  );

  if (existingIndex >= 0) {
    calendar.events[existingIndex] = updatedEvent;
  } else {
    calendar.events.push(updatedEvent);
  }

  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(calendar));
  return { success: true, event: updatedEvent };
}

export function deleteLocalEvent(eventId) {
  const calendar = getLocalStorageCalendar();
  calendar.events = calendar.events.filter((e) => e.id !== eventId);
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(calendar));
  return { success: true };
}
